module.exports = __webpack_public_path__ + "static/floor-d6b5e189aac93bc29fb9cbde24e337b5.jpeg";